import { ref } from "vue";
import { defineStore } from "pinia";

export type NotifType = "success" | "error" | "warning" | "info";

export interface Notification {
  type: NotifType,
  title: string,
  bodyText?: string,
  id?: number
}

let nextId = 0;
function getNextId() { return nextId++ }

export const useToasterStore = defineStore("toaster", () => {
  const notifications = ref<Notification[]>([]);

  function triggerNotif(payload: Notification) {
    const id = getNextId();
    notifications.value.push({ ...payload, id });
    setTimeout(() => {
      removeNotif(id);
    }, 5000); // Remove after 5 seconds
  }

  function removeNotif(id: number) {
    notifications.value = notifications.value.filter(n => n.id !== id);
  }

  return {
    notifications,
    triggerNotif,
    removeNotif,
  };
});
